module.exports = __webpack_public_path__ + "static/media/480.e214a557.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-pliers/dark/480.png
// module id = 2350
// module chunks = 2